import { create } from 'zustand';
import { SpecPackage } from '../types/spec';

interface WorkspaceState {
  currentPackage: SpecPackage | null;
  isLoading: boolean;
  error: string | null;
  selectedPreset: string | null;
  
  setPackage: (pkg: SpecPackage) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setSelectedPreset: (presetName: string | null) => void;
  resetWorkspace: () => void;
}

export const useWorkspaceStore = create<WorkspaceState>((set) => ({
  currentPackage: null,
  isLoading: false,
  error: null,
  selectedPreset: null,

  setPackage: (currentPackage) => set({ currentPackage, isLoading: false, error: null }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error, isLoading: false }),
  setSelectedPreset: (selectedPreset) => set({ selectedPreset }),
  resetWorkspace: () => set({ currentPackage: null, isLoading: false, error: null, selectedPreset: null })
}));
